import { Order, ORDER_TYPE, OrderTypeStrings } from '../types';

const isOceanOrder = (orderType: OrderTypeStrings): boolean => {
    return (
        orderType === ORDER_TYPE.OCEAN_IMPORT ||
            orderType === ORDER_TYPE.OCEAN_EXPORT
        // TODO: remove import/export once removed from backend
        || orderType === 'Import'
        || orderType === 'Export'
    );
};

const isRailOrder = (orderType: OrderTypeStrings): boolean => {
    return (
        orderType === ORDER_TYPE.RAIL_PICK_UP ||
        orderType === ORDER_TYPE.RAIL_DELIVERY
    );
};
const isLandOrder = (orderType: OrderTypeStrings): boolean => {
    return orderType === ORDER_TYPE.LAND || orderType === 'Land';
};
// TODO: remove import/export once removed from backend
const isOceanImport = (orderType: OrderTypeStrings): boolean => {
    return orderType === ORDER_TYPE.OCEAN_IMPORT || orderType === 'Import';
};
const isOceanExport = (orderType: OrderTypeStrings): boolean => {
    return orderType === ORDER_TYPE.OCEAN_EXPORT || orderType === 'Export';
};
const isDropPick = (orderType: OrderTypeStrings): boolean => {
    return orderType === ORDER_TYPE.DROP_PICK;
};
const isRailPickUp = (orderType: OrderTypeStrings): boolean => {
    return orderType === ORDER_TYPE.RAIL_PICK_UP || orderType === 'RailPickUp';
};
const isRailDropOff = (orderType: OrderTypeStrings): boolean => {
    return orderType === ORDER_TYPE.RAIL_DELIVERY || orderType === 'RailDelivery';
};

export const orderTypeMethodsMixin = {
    methods: {
        isRailOrder(order: Order | null | undefined): boolean {
            if (!order) return false;
            return isRailOrder(order.orderType);
        },
        isLandOrder(order: Order | null | undefined): boolean {
            if (!order) return false;
            return isLandOrder(order.orderType);
        },
        isOceanImport(order: Order | null | undefined): boolean {
            if (!order) return false;
            return isOceanImport(order.orderType);
        },
        isOceanExport(order: Order | null | undefined): boolean {
            if (!order) return false;
            return isOceanExport(order.orderType);
        },
        isDropPick(order: Order | null | undefined): boolean {
            if (!order) return false;
            return isDropPick(order.orderType);
        },
        isRailPickUp(order: Order | null | undefined): boolean {
            if (!order) return false;
            return isRailPickUp(order.orderType);
        },
        isRailDropOff(order: Order | null | undefined): boolean {
            if (!order) return false;
            return isRailDropOff(order.orderType);
        },
    },
};

// Only use this mixin if you have a data or prop on your component that is .orderType
// The computed properaties assume .orderType is a data or prop on this Vue class
export const orderTypeMixin = {
    computed: {
        isOceanOrder(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isOceanOrder(dataOrPropOrderType);
        },
        isRailOrder(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isRailOrder(dataOrPropOrderType);
        },
        isLandOrder(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isLandOrder(dataOrPropOrderType);
        },
        isOceanImport(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isOceanImport(dataOrPropOrderType);
        },
        isOceanExport(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isOceanExport(dataOrPropOrderType);
        },
        isDropPick(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isDropPick(dataOrPropOrderType);
        },
        isRailPickUp(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isRailPickUp(dataOrPropOrderType);
        },
        isRailDropOff(): boolean {
            const dataOrPropOrderType = (this as any).orderType;
            return isRailDropOff(dataOrPropOrderType);
        },
    },
};
